// export const ACCOUNT_INITIALIZE = "ACCOUNT_INITIALIZE"
export const LOGIN = "LOGIN"
export const LOGOUT = "LOGOUT"
export const SET_PROFILE = "SET_PROFILE"
